export const articles = [
  {
    id: 1,
    title: '打屁股游戏怎么玩？新手入门全攻略',
    slug: 'beginner-guide',
    category: 'hudong-party',
    image: 'https://readdy.ai/api/search-image?query=Friendly%20group%20of%20people%20playing%20fun%20party%20game%20together%20in%20a%20bright%20living%20room%2C%20warm%20lighting%2C%20happy%20expressions%2C%20clean%20minimalist%20composition%2C%20soft%20shadows&width=800&height=500&seq=article-beginner&orientation=landscape',
    excerpt: '初次接触打屁股游戏？这篇攻略带你从零开始，了解基本规则、玩法和注意事项。',
    content: `
      <h2>什么是打屁股游戏？</h2>
      <p>打屁股游戏是一类以趣味惩罚为核心机制的互动休闲游戏。游戏规则简单易懂：参与者通过竞技、运气或策略对决，输家需要接受"打屁股"的趣味惩罚。这类游戏融合了竞技性与娱乐性，非常适合朋友聚会、团建活动、家庭娱乐等场景。</p>
      
      <h2>基本规则</h2>
      <p>打屁股游戏的基本规则非常简单：</p>
      <ul>
        <li><strong>参与人数：</strong>通常2-10人，部分游戏支持更多人参与</li>
        <li><strong>游戏流程：</strong>通过某种竞技方式（猜拳、掷骰子、抽牌等）决出胜负</li>
        <li><strong>惩罚机制：</strong>输家接受打屁股惩罚，力度和次数由规则决定</li>
        <li><strong>安全原则：</strong>惩罚力度适中，以趣味为主，不可过度用力</li>
      </ul>
      
      <h2>热门玩法推荐</h2>
      <p>以下是几种最受欢迎的打屁股游戏玩法：</p>
      <h3>1. 猜拳打屁股</h3>
      <p>最经典的玩法。两人猜拳，输的一方被打屁股。可以设定连输的惩罚加倍，增加刺激感。</p>
      <h3>2. 骰子打屁股</h3>
      <p>掷骰子决定惩罚次数。点数越大惩罚越重，考验运气的时候到了！</p>
      <h3>3. 真心话大冒险打屁股版</h3>
      <p>在经典真心话大冒险基础上加入打屁股惩罚，输家可以选择真心话或接受打屁股。</p>
      
      <h2>注意事项</h2>
      <p>游戏以娱乐为目的，请注意以下事项：</p>
      <ul>
        <li>控制力度，以轻拍为主，不要用力过猛</li>
        <li>尊重参与者意愿，允许选择替代惩罚</li>
        <li>未成年人参与需有成人陪同</li>
        <li>选择合适的游戏场地，确保安全</li>
      </ul>
    `,
    author: '游戏达人小王',
    date: '2026-08-01',
    readTime: '8分钟',
    tags: ['新手攻略', '入门指南', '游戏规则'],
    featured: true,
  },
  {
    id: 2,
    title: '派对必备！最适合聚会的5款打屁股游戏',
    slug: 'top-5-party-games',
    category: 'hudong-party',
    image: 'https://readdy.ai/api/search-image?query=Exciting%20party%20scene%20with%20group%20of%20friends%20playing%20fun%20games%20in%20a%20bright%20room%2C%20colorful%20decorations%2C%20warm%20lighting%2C%20happy%20atmosphere%2C%20clean%20minimalist%20composition&width=800&height=500&seq=article-party-games&orientation=landscape',
    excerpt: '朋友聚会不知道玩什么？这5款打屁股游戏绝对是派对气氛的催化剂！',
    content: `
      <h2>派对打屁股游戏推荐</h2>
      <p>朋友聚会最怕冷场？试试这些打屁股游戏，保证全场气氛燃爆！以下推荐5款最适合派对的打屁股游戏。</p>
      
      <h3>第1名：真心话大冒险打屁股版</h3>
      <p>聚会必备神作！融合经典真心话大冒险与打屁股惩罚，让每个参与者都充满期待和紧张感。</p>
      
      <h3>第2名：数字炸弹打屁股</h3>
      <p>猜数字范围逐渐缩小，紧张感持续升级。当数字范围缩到个位数时，每个人都屏住呼吸！</p>
      
      <h3>第3名：抢凳子打屁股版</h3>
      <p>音乐停止的瞬间，所有人疯狂抢凳子。没抢到的人不仅要出局，还要接受打屁股惩罚！</p>
      
      <h3>第4名：扑克牌比大小惩罚</h3>
      <p>简单粗暴的玩法，抽牌比大小，瞬间出结果。适合快速轮换，让每个人都有参与感。</p>
      
      <h3>第5名：猜拳打屁股挑战</h3>
      <p>经典永远是经典！猜拳打屁股简单易上手，不需要任何道具，随时随地可以开始。</p>
      
      <h2>派对游戏小贴士</h2>
      <ul>
        <li>准备一些小道具增加趣味性</li>
        <li>播放欢快的背景音乐</li>
        <li>准备饮料和小零食</li>
        <li>控制游戏节奏，避免过度疲劳</li>
      </ul>
    `,
    author: '派对策划师小李',
    date: '2026-07-28',
    readTime: '6分钟',
    tags: ['派对游戏', '聚会推荐', '热门排行'],
    featured: true,
  },
  {
    id: 3,
    title: '手机上的打屁股游戏APP推荐',
    slug: 'best-mobile-apps',
    category: 'mobile-fun',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20game%20app%20interface%20on%20a%20bright%20desk%20with%20minimal%20decor%2C%20warm%20lighting%2C%20clean%20modern%20composition%2C%20soft%20shadows&width=800&height=500&seq=article-mobile-apps&orientation=landscape',
    excerpt: '想在手机上体验打屁股游戏的乐趣？这里有最全的手机游戏APP推荐。',
    content: `
      <h2>手机打屁股游戏推荐</h2>
      <p>随着移动互联网的发展，打屁股游戏也进入了手机时代。以下推荐几款好玩的手机打屁股游戏。</p>
      
      <h3>1. 摇一摇打屁股</h3>
      <p>利用手机加速度传感器，通过摇动手机来决定惩罚力度。摇得越猛，惩罚越重！操作简单，反馈即时，非常适合朋友间快速对决。</p>
      
      <h3>2. 触屏打屁股模拟器</h3>
      <p>在屏幕上滑动手指，速度和力度决定打屁股的效果。游戏配有搞笑的音效和动画反馈，趣味性十足。</p>
      
      <h3>3. 联机对战打屁股</h3>
      <p>支持多人在线对战，通过小游戏决出胜负，输家接受虚拟打屁股惩罚。可以和远方的朋友一起玩！</p>
      
      <h2>选择建议</h2>
      <p>选择手机打屁股游戏时，建议关注以下几点：</p>
      <ul>
        <li>界面设计是否清晰友好</li>
        <li>玩法是否简单易上手</li>
        <li>是否支持多人模式</li>
        <li>用户评价和口碑如何</li>
      </ul>
    `,
    author: '数码玩家小张',
    date: '2026-07-25',
    readTime: '5分钟',
    tags: ['手机游戏', 'APP推荐', '移动端'],
    featured: false,
  },
  {
    id: 4,
    title: '情侣打屁股游戏玩出甜蜜感',
    slug: 'couple-game-tips',
    category: 'couple-games',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20playing%20fun%20game%20together%20in%20a%20cozy%20bright%20room%2C%20warm%20intimate%20lighting%2C%20happy%20expressions%2C%20clean%20minimalist%20composition%2C%20soft%20shadows&width=800&height=500&seq=article-couple-tips&orientation=landscape',
    excerpt: '情侣之间如何玩打屁股游戏？掌握这些技巧，让游戏变成增进感情的甜蜜时刻。',
    content: `
      <h2>情侣打屁股游戏指南</h2>
      <p>打屁股游戏不只是朋友间的娱乐，情侣之间玩起来更有别样的甜蜜感。关键是要把握好分寸和氛围。</p>
      
      <h3>适合情侣的玩法</h3>
      <p><strong>骰子游戏：</strong>掷骰子决定惩罚次数，输赢靠运气，不会伤感情。可以设定温柔的惩罚方式，比如轻轻拍打。</p>
      <p><strong>猜拳游戏：</strong>简单的猜拳，输的人撒娇求饶，赢的人温柔"惩罚"，互动感满分。</p>
      <p><strong>扑克牌游戏：</strong>抽牌比大小，可以设定有趣的赌注和奖励，增加游戏的期待感。</p>
      
      <h3>情侣游戏注意事项</h3>
      <ul>
        <li>以温柔和甜蜜为基调，不要把游戏变成真正的惩罚</li>
        <li>尊重对方的感受，随时可以喊停</li>
        <li>可以加入拥抱、亲吻等甜蜜互动作为"惩罚"的替代</li>
        <li>创造浪漫的游戏环境，如点上香薰蜡烛</li>
      </ul>
    `,
    author: '情感达人小美',
    date: '2026-07-22',
    readTime: '5分钟',
    tags: ['情侣游戏', '感情升温', '互动技巧'],
    featured: false,
  },
  {
    id: 5,
    title: '打屁股游戏的趣味惩罚创意大全',
    slug: 'creative-punishments',
    category: 'fun-punish',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20fun%20punishment%20game%20props%20like%20soft%20cushions%20and%20funny%20accessories%20on%20a%20bright%20table%2C%20playful%20atmosphere%2C%20warm%20lighting%2C%20clean%20minimalist%20composition&width=800&height=500&seq=article-creative-punish&orientation=landscape',
    excerpt: '打屁股太单调？这里有20种创意惩罚方式，让你的游戏更加丰富多彩！',
    content: `
      <h2>创意惩罚方式集锦</h2>
      <p>打屁股游戏的核心是趣味惩罚，但惩罚方式可以有很多创意变化。以下收集了各种有趣的惩罚创意：</p>
      
      <h3>经典惩罚类</h3>
      <ul>
        <li><strong>轻拍拍：</strong>最经典的打屁股惩罚，力度适中</li>
        <li><strong>拍手数：</strong>按照骰子点数决定拍打次数</li>
        <li><strong>挑战拍：</strong>赢家提出挑战要求，输家接受后执行</li>
      </ul>
      
      <h3>搞笑惩罚类</h3>
      <ul>
        <li><strong>学动物叫：</strong>被惩罚前要先学一种动物叫</li>
        <li><strong>绕口令：</strong>被惩罚前念一段绕口令</li>
        <li><strong>模仿秀：</strong>模仿赢家指定的人物或动作</li>
      </ul>
      
      <h3>互动惩罚类</h3>
      <ul>
        <li><strong>拥抱惩罚：</strong>用拥抱代替打屁股</li>
        <li><strong>按摩惩罚：</strong>给赢家按摩作为惩罚</li>
        <li><strong>唱歌惩罚：</strong>唱一首歌才能免除打屁股</li>
      </ul>
      
      <p>创意惩罚让游戏更加丰富多彩，也让每个人都有更多参与感和期待感！</p>
    `,
    author: '游戏设计师大刘',
    date: '2026-07-20',
    readTime: '7分钟',
    tags: ['惩罚创意', '游戏设计', '趣味玩法'],
    featured: true,
  },
  {
    id: 6,
    title: '亲子打屁股游戏：寓教于乐的家庭时光',
    slug: 'family-game-guide',
    category: 'kids-fun',
    image: 'https://readdy.ai/api/search-image?query=Happy%20family%20with%20parents%20and%20children%20playing%20fun%20games%20together%20in%20a%20bright%20living%20room%2C%20warm%20lighting%2C%20joyful%20expressions%2C%20clean%20minimalist%20composition&width=800&height=500&seq=article-family-guide&orientation=landscape',
    excerpt: '如何将打屁股游戏变成寓教于乐的亲子活动？这里有专业的亲子游戏指导。',
    content: `
      <h2>亲子打屁股游戏指南</h2>
      <p>打屁股游戏在亲子互动中可以发挥独特的作用，既能增进亲子关系，又能培养孩子的规则意识和抗挫折能力。</p>
      
      <h3>适合亲子的游戏</h3>
      <p><strong>拍拍乐游戏：</strong>孩子和父母互相轻轻拍打，伴随着快乐的节奏和笑声。重点是互动和欢笑，而非惩罚。</p>
      <p><strong>数字游戏：</strong>结合数字学习的打屁股游戏，答对问题可以轻拍父母，答错被轻拍。寓教于乐！</p>
      
      <h3>亲子游戏原则</h3>
      <ul>
        <li>以鼓励和欢笑为主，不要带有惩罚性质</li>
        <li>让孩子有赢的机会，增强自信心</li>
        <li>游戏时间控制在15分钟以内</li>
        <li>父母要主动示范正确的游戏态度</li>
        <li>游戏后给予孩子积极的反馈和拥抱</li>
      </ul>
    `,
    author: '亲子教育专家陈老师',
    date: '2026-07-18',
    readTime: '6分钟',
    tags: ['亲子游戏', '家庭教育', '寓教于乐'],
    featured: false,
  },
];